module.exports = __webpack_public_path__ + "static/essential-logo-2e3e2361524a5b5a97a2f56947fca452.jpeg";